import { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';

import { Icon } from '@shared/ui/components/Icon';

type SidebarProps = PropsWithChildren<{
  sectionLink?: {
    label: string;
    href: string;
  };
}>;

export function Sidebar({ sectionLink, children }: SidebarProps) {
  return (
    <div className="flex flex-col justify-between h-full">
      <div className="overflow-auto py-3 flex flex-col lg:h-[calc(100vh-114px)]">{children}</div>
      {sectionLink && (
        <div className="h-[44px] flex-shrink-0">
          <Link
            to={sectionLink.href}
            className="h-full flex gap-2 items-center pl-6 no-underline font-medium text-white bg-[#383e70] hover:bg-[#4a5184]"
          >
            {sectionLink.label}
            <Icon icon="external-link" className="text-xl -translate-y-px" />
          </Link>
        </div>
      )}
    </div>
  );
}
